import DOMPurify from 'isomorphic-dompurify';

const BLOCK_TAG =
  /<\/?(?:p|div|br|li|ul|ol|h[1-6]|blockquote|pre|tr|td|th)\b[^>]*>/g;

// Studio-authored fields come out of a rich-text editor, so anywhere the value
// lands in a plain-text slot — a meta description, an OG card — the markup
// would be shown as literal text instead of read as text.
//
// Parsed rather than pattern-matched, in two steps. Sanitizing first drops
// <script>/<style> along with their contents, which a tag strip alone would
// leave behind as visible text. Turning block-level tag boundaries into spaces
// keeps two paragraphs from reading as one word; inline tags just drop, so a
// bold word before a comma does not gain a space. Reading the result back as
// text is what decodes entities — every entity the editor emits, not a
// hand-listed few, which is how &mdash; and &rsquo; used to reach Google raw.
//
// Its own module rather than lib/utils: isomorphic-dompurify declares no
// `sideEffects: false`, and lib/utils is imported by nearly every client
// component, so putting it there risks the parser in chunks that never use it.
export const toPlainText = (html: string | null | undefined): string => {
  const spaced = DOMPurify.sanitize(html ?? '').replace(BLOCK_TAG, ' ');
  const text = DOMPurify.sanitize(spaced, { RETURN_DOM: true }).textContent ?? '';
  return text.replace(/\s+/g, ' ').trim();
};
